import React from 'react'
import { 
    Pagination, PaginationItem, Stack, 
    //Button, Box, Paper
} from '@mui/material'

import { ArrowBack, ArrowForward } from '@mui/icons-material'

const Paginate = ({ page, items, changePage, count}) => {
    //console.log(items, 'ÍTEMS')
    if (items.length === 0 || count <= 1) {
        return null
    }

    
    return (
        <>  
            <Stack spacing={6} py={2}>
                <Pagination
                    size="large"
                    onChange={ (_, p) => {
                        changePage(p)
                    }}
                    //siblingCount={0} 
                    boundaryCount={0}
                    page={page}
                    count={count}
                    renderItem={ item => (
                        <PaginationItem
                            components={{ previous: ArrowBack, next: ArrowForward }}
                            {...item}
                        />)
                    }
                />
            </Stack>
        </>
    ) 
}

export default Paginate